module.exports = __webpack_public_path__ + "img/Toselandf.bbba4486.jpg";